import $ from 'expose-loader?exposes=$,jQuery!jquery'
import { Modal } from 'bootstrap'
import { parseResponse, xssFormat } from './utils'

const edit = (type, id) => {
  const label = $('.service_label_' + type + '_' + id).text(),
    modal = $('#service_label_modal')

  modal.find('.service_label_success').attr('data-id', id)
  modal.find('.service_label_success').attr('data-type', type)
  modal.find('input[name="servicelabel"]').val(label)

  const bsModal = Modal.getOrCreateInstance('#service_label_modal')
  bsModal.show()
  return false
}

const apply = (type, id, label) => $('.service_label_' + type + '_' + id).html(label)

const update = (type, id, servicelabel) => {
  const details = { id, servicelabel }
  if (type === 'account') {
    $.post('?cmd=clientarea&action=label', details, function (data) {
      parseResponse(data)
      apply(type, id, servicelabel)
    })
  } else if (type === 'domain') {
    $.post('?cmd=clientarea&action=labeldomain', details, function (data) {
      parseResponse(data)
      apply(type, id, servicelabel)
    })
  }
}

const save = remove => {
  const modal = $('#service_label_modal'),
    id = modal.find('.service_label_success').attr('data-id'),
    type = modal.find('.service_label_success').attr('data-type'),
    label = remove === true ? '' : xssFormat(modal.find('input[name="servicelabel"]').val());

  const bsModal = Modal.getInstance('#service_label_modal')
  bsModal.hide()
  update(type, id, label)
  return false
}

export default {
  edit,
  apply,
  update,
  save
}
